import React from 'react'
import Image from 'next/legacy/image'
import {useTranslation} from 'next-i18next'
import {Flex, Text} from '@chakra-ui/react'
import StringHelper from '../../../helpers/StringHelper/StringHelper'

const getEngravingMediaUrl = (value: string) => {
    if (process.env.NEXT_PUBLIC_MAGENTO_API_URL_REST) {
        return `${process.env.NEXT_PUBLIC_MAGENTO_API_URL_REST}media/engraves/${value}`
    }
}

export const RenderEngvValue = ({code, value}: any) => {
    const {t} = useTranslation('engraving')
    switch (code) {
        case 'graw_reczny':
            return <Text>{StringHelper.parseStringToHTML(value)}</Text>

        case 'graw_masz_spec':
        case 'graw_masz_spec_2':
        case 'malowanie_2':
            const image = value.includes(';base64,') ? value : getEngravingMediaUrl(value)
            return (
                <Flex borderWidth="1px">
                    {image && (
                        <Image
                            src={image}
                            alt="preview"
                            height="32"
                            width="32"
                            layout="intrinsic"
                        />
                    )}
                </Flex>
            )
        case 'graw_masz_spec_1':
            const splitedEngvFont = value.split(/(.*.*?)\|/)
            const msg = StringHelper.parseStringToHTML(splitedEngvFont[1] || '')
            return (
                <Text>
                    <Text as="span" pr={8}>
                        {splitedEngvFont[2] || ''}
                    </Text>
                    {msg}
                </Text>
            )
        case 'malowanie_1':
            const splitedEngvColor = value.split(/(.*.*?)\|/)
            return (
                <Text>
                    {t('COLOR')}: {t(splitedEngvColor[2] || '')}
                    <br/>
                    {t('CONTENT')}: {splitedEngvColor[1] || ''}
                </Text>
            )
        default:
            return null
    }
}
